<template>
    <div class="captcha-wrapper">
        <div :key="captchaKey" id="captcha-element"></div>
    </div>
</template>

<script>
export default {
    name: 'AlyRange',
    props: {
        scene: {
            type: String,
            default: 'login'
        },
        width: {
            type: Number,
            default: 354
        }
    },
    data() {
        return {
            captchaKey: 0,
            captchaInstance: null
        };
    },
    mounted() {
        this.initRange();
    },
    methods: {
        initRange() {
            const that = this
            // 验证码 2.0 初始化
            window.initAliyunCaptcha({
                // 场景 ID，从阿里云验证码控制台获取
                SceneId: '10f3z7h0',
                // 验证码模式，popup 表示弹出式，embed 表示嵌入式
                mode: 'embed',
                // 页面上预留的渲染验证码的元素
                element: '#captcha-element',
                // 验证码验证通过回调函数
                success: function (captchaVerifyParam) {
                    // 入参为验签 captchaVerifyParam，直接传递给后端进行验签
                    // console.log('验证通过:', captchaVerifyParam)
                    that.$emit('success', captchaVerifyParam)
                },
                // 验证码验证不通过回调函数
                fail: function (result) {
                    // 正常验证有效期内不需要做任何操作，验证码自动刷新，重新进行验证
                    console.error('验证失败:', result)
                },
                // 验证码加载出现异常时触发该回调参数
                onError: function (errorCode) {
                    console.error('验证码加载异常:', errorCode)
                },
                // 绑定验证码实例回调函数，该回调会在验证码初始化成功后调用
                getInstance: function (instance) {
                    that.captchaInstance = instance
                },
                // 滑块验证的框体样式，支持自定义宽度和高度
                slideStyle: {
                    width: that.width,
                    height: 40
                }
            })
        },
        resetRange() {
            this.captchaKey++
            this.captchaInstance = null
            this.$nextTick(() => {
                this.initRange()
            })
        }

    }
};
</script>

<style>
.captcha-wrapper {
    background-color: #f1f1f2;
    /* 与滑块验证的框体样式一致 */
    height: 40px;
}

.btn_slide {
    height: 34px !important;
}

.btn_ok {
    height: 34px !important;
}

.nc-lang-cnt {
    height: 34px !important;
}

.sm-pop-inner {
    width: auto !important;
    left: 50%;
    transform: translateX(-50%);
}
</style>
